// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"112":"work","420":"message","539":"misc","644":"account","857":"report","884":"admin"}[chunkId] || chunkId) + "." + {"112":"c8c75f64","368":"84e95fdb","420":"ac42c22d","516":"6cdf8066","539":"52595948","644":"9684a29e","857":"1f97a0c8","884":"178c505a","945":"6b5f1285"}[chunkId] + ".js";
};